// extracted by mini-css-extract-plugin
export default {"divergencyTag":"Tag_divergencyTag__R+Ae-"};